var map = {
	"./ARE_36.png": 6287,
	"./ARE_48.png": 5304,
	"./ARE_64.png": 4178,
	"./AUS_36.png": 5513,
	"./AUS_48.png": 5229,
	"./AUS_64.png": 4922,
	"./BGD_36.png": 554,
	"./BGD_48.png": 9155,
	"./BGD_64.png": 861,
	"./BRU_36.png": 837,
	"./BRU_48.png": 3279,
	"./BRU_64.png": 347,
	"./CAN_36.png": 6066,
	"./CAN_48.png": 6966,
	"./CAN_64.png": 509,
	"./CHE_36.png": 459,
	"./CHE_48.png": 6306,
	"./CHE_64.png": 3909,
	"./CHN_36.png": 2799,
	"./CHN_48.png": 8774,
	"./CHN_64.png": 9478,
	"./DNK_36.png": 3987,
	"./DNK_48.png": 9308,
	"./DNK_64.png": 9544,
	"./EEE_36.png": 1128,
	"./EEE_48.png": 117,
	"./EEE_64.png": 3107,
	"./GBR_36.png": 8361,
	"./GBR_48.png": 8032,
	"./GBR_64.png": 899,
	"./HKG_36.png": 7516,
	"./HKG_48.png": 3858,
	"./HKG_64.png": 2086,
	"./IDN_36.png": 3697,
	"./IDN_48.png": 7387,
	"./IDN_64.png": 6362,
	"./JPN_36.png": 6814,
	"./JPN_48.png": 3030,
	"./JPN_64.png": 7252,
	"./MYS_36.png": 351,
	"./MYS_48.png": 5784,
	"./MYS_64.png": 5168,
	"./NOR_36.png": 2474,
	"./NOR_48.png": 9962,
	"./NOR_64.png": 6320,
	"./NZL_36.png": 6356,
	"./NZL_48.png": 1449,
	"./NZL_64.png": 2999,
	"./PHL_36.png": 8117,
	"./PHL_48.png": 8439,
	"./PHL_64.png": 915,
	"./QAT_36.png": 4387,
	"./QAT_48.png": 209,
	"./QAT_64.png": 980,
	"./SAU_36.png": 2223,
	"./SAU_48.png": 4199,
	"./SAU_64.png": 8033,
	"./SGP_36.png": 4704,
	"./SGP_48.png": 3195,
	"./SGP_64.png": 2258,
	"./SWE_36.png": 7663,
	"./SWE_48.png": 5421,
	"./SWE_64.png": 5107,
	"./THA_36.png": 9773,
	"./THA_48.png": 5602,
	"./THA_64.png": 2681,
	"./USA_36.png": 4675,
	"./USA_48.png": 9000,
	"./USA_64.png": 514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2661;